export default class ApplicationHeader {
  constructor() {
    $(window).scroll(function() {
      let heroHeight = $($('.c-application-hero').first()).outerHeight();
      let headerHeight = $($('.c-application-header').first()).outerHeight();
      let breakpoint = heroHeight - headerHeight;

      if (window.pageYOffset > breakpoint) {
        $('.c-application-header').addClass('c-application-header--is-inverted');
      } else {
        $('.c-application-header').removeClass('c-application-header--is-inverted');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/application-header.js